module.exports = __webpack_public_path__ + "static/img/introduction-environmental-strategy-hero-lowres.55e8568.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-environmental-strategy-hero-lowres.jpg
// module id = 2Hm/
// module chunks = 0